var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.66797 4.66667H4.0013C3.64768 4.66667 3.30854 4.80714 3.05849 5.05719C2.80844 5.30724 2.66797 5.64638 2.66797 6V12C2.66797 12.3536 2.80844 12.6928 3.05849 12.9428C3.30854 13.1929 3.64768 13.3333 4.0013 13.3333H10.0013C10.3549 13.3333 10.6941 13.1929 10.9441 12.9428C11.1942 12.6928 11.3346 12.3536 11.3346 12V11.3333M10.668 3.33333L12.668 5.33333M13.5913 4.39C13.8539 4.12744 14.0014 3.77132 14.0014 3.4C14.0014 3.02868 13.8539 2.67257 13.5913 2.41C13.3287 2.14744 12.9726 1.99993 12.6013 1.99993C12.23 1.99993 11.8739 2.14744 11.6113 2.41L6.0013 8V10H8.0013L13.5913 4.39Z",
    stroke: "white",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.4cb14dc701bd258c755715653cc63af5.svg";
export { ForwardRef as ReactComponent };